import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import {getReservationInfo} from "../../services/reservation/reservation";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function ReservationInfoForm({reservationId, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [reserveId, setReservationId] = useState(reservationId);
  const [reservation, setReservation] = useState({});
  const [agentName, setAgentName] = useState("");
  const [agentFamily, setAgentFamily] = useState("");
  const [branchTitle, setBranchTitle] = useState("");
  const [fieldTitle, setFieldTitle] = useState("");
  const [topic, setTopic] = useState("");
  const [challenge, setChallenge] = useState("");
  const [clientName, setClientName] = useState("");
  const [clientFamily, setClientFamily] = useState("");
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [status, setStatus] = useState(false);


  useEffect(() => {
    async function getData(reservationId) {
      const result = await getReservationInfo(reserveId);
      if (result.status === 200) {
        const {reservation} = result.data;
        setReservation(reservation || {});
      }
    }

    getData(reservationId);
  }, [reservationId]);

  useEffect(() => {
    setAgentName(reservation?.agent_name ?? "")
    setAgentFamily(reservation?.agent_family ?? "")
    setBranchTitle(reservation?.branch_title ?? "")
    setFieldTitle(reservation?.field_title ?? "")
    setTopic(reservation?.topic ?? "")
    setChallenge(reservation?.challenge ?? "")
    setClientName(reservation?.client_name ?? "")
    setClientFamily(reservation?.client_family ?? "")
    setTitle(reservation?.title ?? "")
    setDate(reservation?.date ?? "")
    setStartTime(reservation?.start_time ?? "")
    setEndTime(reservation?.end_time ?? "")
    setStatus(reservation?.status === 'enable' ? true : false ?? false)
  }, [reservation]);

  return (
    <>
      <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="bg-gray-800 rounded-2xl border-b -mt-4">
          <Typography className="py-2 w-full text-white text-2xl z-10 textCenter">
            اطلاعات تایم رزرو شده
          </Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="mb-4 border-b">
            <Typography color="blue-gray">
              {`${Dict('agent_name_family')}: ${agentName} ${agentFamily}`}
            </Typography>
          </div>

          <div className="mb-4 border-b">
            <Typography color="blue-gray">
              {`${Dict('field_branch_title')}: ${fieldTitle} - ${branchTitle}`}
            </Typography>
          </div>

          <div className="mb-4 border-b">
            <Typography color="blue-gray">
              {`${Dict('client_name_family')}: ${clientName} ${clientFamily}`}
            </Typography>
          </div>
          
          <div className="mb-4 border-b">
            <Typography color="blue-gray">
              {`${Dict('consultation_topic')}: ${topic}`}
            </Typography>
          </div>

          <div className="mb-4 border-b">
            <Typography color="blue-gray">
              {`${Dict('challenge')}: ${challenge}`}
            </Typography>
          </div>

          <div className="mb-4">
            {/*<Input variant="standard"*/}
            {/*       value={date}*/}
            {/*       label={Dict('date')}*/}
            {/*       placeholder={Dict('date')}*/}
            {/*       onChange={(e) => {*/}
            {/*         e.target.value = date*/}
            {/*       }}*/}
            {/*/>*/}
            <Typography color="blue-gray">
              {`${Dict('date')}: ${persianNumberFormat(date)}`}
            </Typography>
          </div>

          <div className="mb-4 border-b flex flex-row">
            <div className="flex flex-col ml-4">
              <Typography color="blue-gray">
                {`از ساعت: ${persianNumberFormat(startTime)} `}
              </Typography>
            </div>
            <div className="flex flex-col">
              <Typography color="blue-gray">
                {`تا ساعت: ${persianNumberFormat(endTime)}`}
              </Typography>
            </div>
          </div>

          {/*<div className="">*/}
          {/*  <Switch*/}
          {/*    label={*/}
          {/*      <Typography color="blue-gray" className="font-medium">*/}
          {/*        فعال/غیرفعال*/}
          {/*      </Typography>*/}
          {/*    }*/}
          {/*    checked={status}*/}
          {/*    onChange={(e) => {*/}
          {/*      setStatus(e.target.checked)*/}
          {/*    }}*/}
          {/*    labelProps={{className: "mx-4"}}*/}
          {/*  />*/}
          {/*</div>*/}
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>بستن</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}